export const SET_ELCCABINETS = 'ELCCabinet/set';
export const SET_ELCCABINETS_UPDATED = 'ELCCabinet/UpdateStatus/set';
